import { makeStyles } from "@mui/styles";

const ErrorMessageSupportModalStyles = makeStyles((theme) => ({
  message: { marginBottom: 20, color: "black" }
}));

export default ErrorMessageSupportModalStyles;
